// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import AvatarFormController from "./avatar_form_controller"
application.register("avatar-form", AvatarFormController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import TaskScheduleController from "./task_schedule_controller"
application.register("task-schedule", TaskScheduleController)

import QuickTaskController from "./quick_task_controller"
application.register("quick-task", QuickTaskController)

import AutoGrowController from "./auto_grow_controller"
application.register("auto-grow", AutoGrowController)

import CaretEndController from "./caret_end_controller"
application.register("caret-end", CaretEndController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CodexSessionController from "./codex_session_controller"
application.register("codex-session", CodexSessionController)

import CodexRealtimeNotificationController from "./codex_realtime_notification_controller"
application.register("codex-realtime-notification", CodexRealtimeNotificationController)

import FlashController from "./flash_controller"
import PushSubscriptionController from "./push_subscription_controller"
import PasswordVisibility from "@stimulus-components/password-visibility"
application.register("flash", FlashController)
application.register("password-visibility", PasswordVisibility)
application.register("push-subscription", PushSubscriptionController)
